export type ContractErrorCode =
  | "ADMIN_ONLY"
  | "INSUFFICIENT_CARD_BALANCE"
  | "INSUFFICIENT_TOKEN_BALANCE"
  | "INVALID_STATUS"
  | "REPLAY_DETECTED"
  | "INSUFFICIENT_CONTRACT_BALANCE"
  | "SIGNATURE_VERIFICATION_FAILED"
  | "CARD_NOT_FOUND"
  | "MERCHANT_NOT_FOUND"
  | "INSUFFICIENT_GAS"
  | "TX_FAILED"
  | "UNKNOWN";

export class ContractError extends Error {
  constructor(
    public readonly code: ContractErrorCode,
    message: string,
  ) {
    super(message);
    this.name = "ContractError";
  }
}

const CONTRACT_ERROR_MAP: Record<number, { code: ContractErrorCode; message: string }> = {
  6000: { code: "ADMIN_ONLY",                      message: "Only admin can perform this action." },
  6001: { code: "INSUFFICIENT_CARD_BALANCE",       message: "Insufficient card balance." },
  6002: { code: "INSUFFICIENT_TOKEN_BALANCE",      message: "Insufficient token balance." },
  1:    { code: "INSUFFICIENT_TOKEN_BALANCE",      message: "Insufficient token balance." },
  6003: { code: "INVALID_STATUS",                  message: "Invalid card status." },
  6004: { code: "REPLAY_DETECTED",                 message: "Transaction replay detected." },
  6005: { code: "INSUFFICIENT_CONTRACT_BALANCE",   message: "Insufficient contract balance." },
  6006: { code: "SIGNATURE_VERIFICATION_FAILED",   message: "Signature verification failed." },
  6007: { code: "CARD_NOT_FOUND",                  message: "Card not found." },
  6008: { code: "MERCHANT_NOT_FOUND",              message: "Merchant not found." },
};

export function parseEvmError(err: any): ContractError {
  try {
    if (err?.data) {
      const code = parseInt(err.data.slice(0, 10), 16);
      const entry = CONTRACT_ERROR_MAP[code];
      if (entry) return new ContractError(entry.code, entry.message);
    }
    if (err?.reason) return new ContractError("TX_FAILED", err.reason);
    if (err?.message?.includes("insufficient funds")) {
      return new ContractError("INSUFFICIENT_GAS", "Insufficient MATIC for gas fees.");
    }
  } catch (_) {}

  return new ContractError("TX_FAILED", err?.message ?? "Transaction failed.");
}
